import { MODAL_STATUS_TOGGLE } from "./actionTypes";

export const modalStatusToggle = (value = null) => {
    return {
        type: MODAL_STATUS_TOGGLE,
        Platform : value
    }
} 
